var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('common-header',{attrs:{"navArray":_vm.navArray}}),_vm._t("main"),_c('div',{staticClass:"cle"}),_c('common-footer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }